var StateInterceptor = function ($injector, $rootScope, $q) {
    var flowName;

    return {

        response: function (response) {
            if (response?.config?.nointercept) {
                return $q.when(response);
            }
            else {
                var data = response.data;
                if (data.state === 'FULLY_AUTHENTICATED') {
                    var csrfTokenFactory = $injector.get('csrfTokenFactory');
                    response.config.nointercept = true;

                    flowName = data.flowName;
                    if (!flowName) {
                        flowName = $rootScope.flowName;
                    }
                    var tokenData = {
                        token: $window.sessionStorage.csrfToken
                    };
                    if (null !== tokenData && tokenData.token !== undefined) {
                        csrfTokenFactory.saveCSRF(tokenData).then(nextState);
                    }
                    else {
                        nextState();
                    }

                }
            }

            return response;
        }


    }; //End of return

    function nextState() {
        var StateDestinationFactory = $injector.get('StateDestinationFactory');
        var redirectService = $injector.get('redirectService');
        StateDestinationFactory.determineNextDest(flowName)
            .then(function (state) {
                if (state.postRegSummaryUrl !== null || state.postRegSummaryUrl !== "") {
                    $rootScope.postRegSummaryUrl = state.postRegSummaryUrl;
                    $rootScope.regData = state;
                }

                redirectService.redirect(state, 'ALL');
            });
    }
};

StateInterceptor.$inject = ['$injector', '$rootScope', '$q'];
export default StateInterceptor;
